module.exports = __webpack_public_path__ + "img/mulish-v11-latin-300italic.b76f8cc.svg";